import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import { Row, Col, Image } from "react-bootstrap";
import PageHeader from "../PageHeader/PageHeader";
import PageSectionHeader from "../PageSectionHeader/PageSectionHeader";

import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";

const FacultyDevelopmentProgramGallary = () => {
	const [currentBreakPoint, setCurrentBreakPoint] = useState("");

	useEffect(() => {
		bsBreakpoints.init();
		setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

		const handleBreakPoint = (event) => {
			setCurrentBreakPoint(event.detail);
		};

		window.addEventListener("new.bs.breakpoint", handleBreakPoint);

		return () => {
			window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
		};
	}, []);

	const descriptionClasses = classNames("mb-4 text-center text-text-color", {
		"font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
	});

	return (
		<PageSection>
			<PageSection>
				<ResponsivePageHeader title="Gallary" />
				<Row className="justify-content-left">
					<Col md="6" className="mb-4">
						<Image
							src={require("../../assets/faculty-dev-prog/iic 10.JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-4">
						<Image
							src={require("../../assets/faculty-dev-prog/iic 14.jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-4">
						<Image
							src={
								require("../../assets/faculty-dev-prog/fdp (1).jpeg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6" className="mb-4">
						<Image
							src={
								require("../../assets/faculty-dev-prog/fdp (2).jpeg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="6">
						<Image
							src={
								require("../../assets/faculty-dev-prog/fdp (3).jpeg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
				</Row>
			</PageSection>
		</PageSection>
	);
};

export default FacultyDevelopmentProgramGallary;
